/**
 * @generated SignedSource<<1d9c205a45339b5c22ab1bbe65fb3c98>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject$data = {
  readonly fieldSets: {
    readonly __id: string;
    readonly " $fragmentSpreads": FragmentRefs<"columnPicker_issueViewChildIssuesPanel" | "ui_nativeIssueTable_NativeIssueTable_columns">;
  } | null | undefined;
  readonly hasDefaultFieldSets: boolean | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject";
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject$key = {
  readonly " $data"?: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject">;
};

import ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery_graphql from './ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "amountOfColumns"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [
        "node"
      ],
      "operation": ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "hasDefaultFieldSets"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "fieldSetSelectedState": "SELECTED"
          }
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "amountOfColumns"
        }
      ],
      "concreteType": "JiraIssueSearchFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSets",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_nativeIssueTable_NativeIssueTable_columns"
        },
        {
          "kind": "FragmentSpread",
          "name": "columnPicker_issueViewChildIssuesPanel"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraFieldSetView"
};

(node as any).hash = "242632a44472c0107adea6461f6f5fe4";

export default node;
